import { PaymentMethod } from '../../../invoicingSettings/types/paymentMethod'
import type { DisplayedPaymentMethods } from '../../types/invoiceForm/displayedPaymentMethods'
import type { InvoicePaymentMeanPayload } from '../../types/invoicePayload/invoicePaymentMeansPayload'
import { filterDisplayedPaymentMethods } from '../filterDisplayedPaymentMethods'

// takes the payment methods that come from Zervant Settings and removes all props except for
// types and fields (as only these two are expected by the invoicing API when saving a draft)
export const getPaymentMeansPayload = (
  paymentMethods?: PaymentMethod[],
  displayedPaymentMethods?: DisplayedPaymentMethods,
): InvoicePaymentMeanPayload[] =>
  filterDisplayedPaymentMethods(paymentMethods, displayedPaymentMethods).map(({ type, fields }) => ({ type, fields }))
